import script from "./GenreTab.vue?vue&type=script&setup=true&lang=js"
export * from "./GenreTab.vue?vue&type=script&setup=true&lang=js"

import "./GenreTab.vue?vue&type=style&index=0&id=0a48b353&scoped=true&lang=css"

import exportComponent from "/home/jenkins/storybird-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a48b353"]])

export default __exports__